import React, { Fragment, useEffect, useRef } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { useLocation } from 'react-router-dom';

const TabletNavDrawer = ({ isOpen, onClose, children }) => {
    const location = useLocation();
    const prevPath = useRef(location.pathname);
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (prevPath.current !== location.pathname) {
            onCloseRef.current();
        }
        prevPath.current = location.pathname;
    }, [location.pathname]);

    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-40 print:hidden" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-150"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-slate-900/15 dark:bg-black/25" aria-hidden="true" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-200"
                            enterFrom="-translate-x-full"
                            enterTo="translate-x-0"
                            leave="ease-in duration-200"
                            leaveFrom="translate-x-0"
                            leaveTo="-translate-x-full"
                        >
                            <Dialog.Panel className="fixed left-0 top-4 bottom-4 w-[min(100vw-3rem,20rem)] max-w-full rounded-r-2xl bg-slate-50 dark:bg-slate-900 shadow-xl border-y border-r border-gray-200 dark:border-slate-700 flex flex-col overflow-hidden">
                                <div className="flex-1 min-h-0 overflow-y-auto no-scrollbar px-4 pt-4 pb-8 dark:text-slate-100 dark:fill-slate-100">
                                    {children}
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default TabletNavDrawer;
